module.exports = __webpack_public_path__ + "assets/img/2203.68184445.svg";